import React from 'react';

import DividerCurveSvg from './svg/DividerCurveSvg';

function DividerCurve({ styles = '', ...rest }) {
    return (
        <div className={styles} {...rest}>
            <DividerCurveSvg />
        </div>
    );
}

export default DividerCurve;
